import React, { useCallback, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { useForm } from "react-hook-form";
import { CheckToken } from "../../login/AccessToken";
import ResendOtpTimer from "../../../components/Utils/ResendOtpTimer";
import { toast } from "react-toastify";
import { displayPatientName } from "../../../utils/displayPatientName";
import { normalizeBase64Image } from "../../utils/utils";
import { Link } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CancelIcon from "@mui/icons-material/Cancel";
import ProfileCard from "./ProfileCard";

const RESEND_OTP_TIMER = process.env.REACT_APP_RESEND_OTP_TIMER;
const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
const REACT_APP_SUFFIX =
  process.env.REACT_APP_IS_ABDM_CONNECTED_WITH_PROD === "true"
    ? process.env.REACT_APP_SUFFIX_PR
    : process.env.REACT_APP_SUFFIX_SB;

const VerifyAbha = ({
  showVerifyModal,
  setShowVerifyModal,
  setHealthIdDetails,
  fetchPatientDetails,
  taggingPatientId,
  setMultiplePatientData,
  setSelectedPartiallyMatchedPatient,
  setPatientData,
  resetForm,
  setTransactionIdForDataVerification,
  onNavigateToGenerateAbha,
  onClose,
}) => {
  const [displayDownloadOTPVerify, setDisplayDownloadOTPVerify] = useState(false);
  const [txnIdDownload, setTxnIdDownload] = useState(false);
  const [dissableAllButtonsVerify, setDissableAllButtonsVerify] = useState(false);
  const [tokenForCardV3, setTokenForCardV3] = useState();
  const [isCardSelectionFrozen, setIsCardSelectionFrozen] = useState(false);
  const [buttonDisabledVerify, setButtonDisabledVerify] = useState(false);
  const [authModes, setAuthModes] = useState(["AADHAAR_OTP", "MOBILE_OTP"]);
  const [otpResendCount, setOtpResendCount] = useState(0);
  const [navigateToAbha, setNavigateToAbha] = useState(false);
  const [patients, setPatients] = useState([]);
  const [selectedPatId, setselectedPatId] = useState(null);
  const [disableForMobileVerify, setDisableForMobileVerify] = useState(false);
  const [patientForMobileSearch, setPatientForMobileSearch] = useState();
  const [continueWithMobileVerification, setContinueWithMobileVerification] = useState(false);
  const [continueWithMobileVerificationVisible, setContinueWithMobileVerificationVisible] = useState(false);
  const [otpResendCountVerifyForMobile, setOtpResendCountVerifyForMobile] = useState(0);
  const [buttonDisabledContinueForMobile, setButtonDisabledContinueForMobile] = useState(false);
  const [isContinueButtonClicked, setIsContinueButtonClicked] = useState(false);
  const [multipleMatchedData, setMultipleMatchedData] = useState([]);
  const [activePatientId, setActivePatientId] = useState(null);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [selectedABHANumber, setSelectedABHANumber] = useState("");
  const [txnIdV3, setTxnIdV3] = useState("");
  const [tokenForCard, setTokenForCard] = useState("");
  const [accounts, setAccounts] = useState([]);

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
  } = useForm();

  const {
    register: register8,
    handleSubmit: handleSubmit8,
    formState: { errors: errors8 },
    getValues: getValues8,
    setValue: setValue8,
  } = useForm();

  const {
    register: register12,
    handleSubmit: handleSubmit12,
  } = useForm();

  const {
    handleSubmit: handleSubmit13,
  } = useForm();

  const {
    handleSubmit: handleSubmit14,
  } = useForm();

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const abhaAddress = watch("health_id");
  const selectedAuthModeW = watch("selected_auth_mode");
  const healthId = watch("health_id");
  const selectedAuthMode = watch("selected_auth_mode");

  useEffect(() => {
    setDisplayDownloadOTPVerify(false);
    setButtonDisabledVerify(false);
    setOtpResendCount(0);
    setTokenForCard("");
    setDissableAllButtonsVerify(false);
    setSelectedABHANumber("");
    setTxnIdV3("");
    setAccounts([]);
    setIsCardSelectionFrozen(false);
    setTokenForCardV3("");
    setValue8("abha_id_otp", "");
    setNavigateToAbha(false);
  }, [abhaAddress, selectedAuthModeW, setValue8]);

  useEffect(() => {
    if (healthId) {
      if (healthId.endsWith(REACT_APP_SUFFIX)) {
        fetchAuthMethodsForAbha(healthId);
      } else if (/^\d+$/.test(healthId)) {
        if (healthId.length === 10) {
          setAuthModes(["MOBILE_OTP"]);
        } else if (healthId.length === 12) {
          setAuthModes(["AADHAAR_OTP"]);
        } else {
          setAuthModes(["AADHAAR_OTP", "MOBILE_OTP"]);
        }
      } else {
        setAuthModes(["AADHAAR_OTP", "MOBILE_OTP"]);
      }
    }
  }, [healthId]);

  useEffect(() => {
    if (authModes.length > 0) {
      setValue("selected_auth_mode", authModes[0]);
    }
  }, [authModes, setValue]);

  useEffect(() => {
    if (
      selectedAuthMode !== undefined &&
      selectedAuthMode.length > 0 &&
      displayDownloadOTPVerify === true
    ) {
      setDisplayDownloadOTPVerify(false);
      setHealthIdDetails(false);
    }
    // Match RegisterPatient.js: only re-run when auth mode changes, not when OTP
    // screen is shown — including displayDownloadOTPVerify in deps hides OTP immediately.
  }, [selectedAuthMode, setHealthIdDetails]);

  const resetVerifyModalState = useCallback(() => {
    setValue("health_id", "");
    setValue8("abha_id_otp", "");
    setDisplayDownloadOTPVerify(false);
    setTokenForCard("");
    setOtpResendCount(0);
    setSelectedABHANumber("");
    setTxnIdV3("");
    setAccounts([]);
    setDissableAllButtonsVerify(false);
    setIsCardSelectionFrozen(false);
    setTokenForCardV3("");
    setNavigateToAbha(false);
    if (multipleMatchedData.length === 0) {
      fetchPatientDetails();
    }
    setMultiplePatientData([]);
    setPatients([]);
    setselectedPatId(null);
    setDisableForMobileVerify(false);
    setPatientForMobileSearch(null);
    setContinueWithMobileVerification(false);
    setContinueWithMobileVerificationVisible(false);
    setOtpResendCountVerifyForMobile(0);
    setButtonDisabledContinueForMobile(false);
    setIsContinueButtonClicked(false);
    setMultipleMatchedData([]);
  }, [
    fetchPatientDetails,
    multipleMatchedData.length,
    setMultiplePatientData,
    setValue,
    setValue8,
  ]);

  // Defer reset until exit animation ends — resetting OTP UI while Transition
  // still owns those nodes causes NotFoundError: removeChild (blank screen).
  const handleCloseVerifyModal = useCallback(() => {
    setShowVerifyModal(false);
  }, [setShowVerifyModal]);

  const handleVerifyModalExited = useCallback(() => {
    resetVerifyModalState();
    onClose?.();
  }, [onClose, resetVerifyModalState]);

  const handleLinkToGenerateAbha = (event) => {
    event?.preventDefault?.();
    handleCloseVerifyModal();
    onNavigateToGenerateAbha?.();
  };

  const onSubmitAccountMobile = (data) => {
    const matchedPatient = patients.find(
      (patient) => patient.patient_id === selectedPatId
    );
    if (matchedPatient) {
      setPatientForMobileSearch(matchedPatient);
    } else {
      console.log("No matching patient found for the given ID.");
    }
  };

  const handleContinueWithMobileVerification = () => {
    setIsContinueButtonClicked(true);

    const requestBody = {
      scope: ["abha-login", "mobile-verify"],
      loginHint: "mobile",
      loginId: getValues("health_id"),
      otpSystem: "abdm",
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.status !== 500 && res.status !== "Failed") {
          console.log(res);
          console.log(res.data);
          if (res.data.txnId !== undefined && res.data.txnId !== null) {
            toast.success("ABHA Exists to communication Mobile");
            setContinueWithMobileVerificationVisible(true);
            toast.success(res.data.message);
            setTxnIdDownload(res.data.txnId);
            setDisplayDownloadOTPVerify(true);
            // handleVerifyOtpResend();
            handleOtpResendForMobileVerify();
          } else if (res.data.loginId === "Invalid LoginId") {
            toast.error("Please enter a valid mobile number");
          } else {
            toast.error(res.data.error.message);
            setButtonDisabledVerify(false);
            if (res.data.error.code === "ABDM-1115") {
              setNavigateToAbha(true);
            }
          }
        } else {
          toast.error("Failed, please try again after sometime!!");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };
  const resendMobileVerifictionOfABHA = () => {
    setContinueWithMobileVerificationVisible(true);
    const requestBody = {
      scope: ["abha-login", "mobile-verify"],
      loginHint: "mobile",
      loginId: getValues("health_id"),
      otpSystem: "abdm",
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.status !== 500 && res.status !== "Failed") {
          console.log(res);
          console.log(res.data);
          if (res.data.txnId !== undefined && res.data.txnId !== null) {
            toast.success("ABHA Exists to communication Mobile");
            toast.success(res.data.message);
            setTxnIdDownload(res.data.txnId);
            setDisplayDownloadOTPVerify(true);
            // handleVerifyOtpResend();
            handleOtpResendForMobileVerify();
          } else if (res.data.loginId === "Invalid LoginId") {
            toast.error("Please enter a valid mobile number");
          } else {
            toast.error(res.data.error.message);
            setButtonDisabledVerify(false);
            if (res.data.error.code === "ABDM-1115") {
              setNavigateToAbha(true);
            }
          }
        } else {
          toast.error("Failed, please try again after sometime!!");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };

  const handleOtpResendForMobileVerify = () => {
    console.log("currentCount", otpResendCountVerifyForMobile);
    if (otpResendCountVerifyForMobile <= 3) {
      setOtpResendCountVerifyForMobile((prevCount) => prevCount + 1);
      setButtonDisabledContinueForMobile(true);

      if (otpResendCountVerifyForMobile < 2) {
        setTimeout(() => {
          setButtonDisabledContinueForMobile(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };
  const fetchAuthMethodsForAbha = (abhaAddress) => {
    if (Token()) {
      console.log("alert data2", getValues("health_id"));

      var post_data = { abhaAddress };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/search_abha_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log("API Response:", res.data);
          if (res.status !== "" && res.status < 300) {
            if (res.data.message) {
              toast.error("Cannot process : " + res.data.message);
              // console.log("Cannot process : " + res.data.message);
              // setValue("health_id", "");
            } else {
              let availableAuthMethods = res.data.authMethods || [];

              // Update authModes based on available auth methods
              if (
                availableAuthMethods.includes("MOBILE_OTP") &&
                availableAuthMethods.includes("AADHAAR_OTP")
              ) {
                setAuthModes(["MOBILE_OTP", "AADHAAR_OTP"]);
              } else if (availableAuthMethods.includes("MOBILE_OTP")) {
                setAuthModes(["MOBILE_OTP"]);
              } else if (availableAuthMethods.includes("AADHAAR_OTP")) {
                setAuthModes(["AADHAAR_OTP"]);
              } else {
                setAuthModes([]);
              }

              console.log("Updated Auth Modes:", authModes);
            }
          } else {
            toast.error("Error : " + (res.data.message || "Unknown error"));
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message || "API call failed");
        });
    }
  };

  const submit = (data, e) => {
    e.preventDefault();
    if (otpResendCount >= 3) {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
      return;
    }
    const auth_mode = getValues("selected_auth_mode");
    if (
      auth_mode === "MOBILE_OTP" &&
      getValues("health_id") &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      let filterCriteria;
      filterCriteria = {
        filter_type: "phone_number",
        filter_details: {
          phone_number: getValues("health_id"),
        },
        multipleResults: true,
      };

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
          filterCriteria,
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "Success") {
            toast.success("Patient Found Successfully");
            // const filteredPatients = response.data.patient_details.filter(
            //   (patient) =>
            //     patient.name &&
            //     patient.patient_id &&
            //     patient.gender &&
            //     patient.dob &&
            //     patient.abha_id &&
            //     patient.abha_no &&
            //     patient.photo
            // );

            setPatients(response.data.patient_details);
            setContinueWithMobileVerification(true);
            setDisableForMobileVerify(true);
          } else if (response.data.status === "Failed") {
            // toast.error(response.data.message);
            toast.error("No Patient Found With This Mobile No");
            // handleContinueWithMobileVerification()
            console.log("alert data", auth_mode);
            console.log("alert data2", getValues("health_id"));
            const requestBody = {
              scope: ["abha-login", "mobile-verify"],
              loginHint: "mobile",
              loginId: getValues("health_id"),
              otpSystem: "abdm",
            };
            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
                JSON.stringify(requestBody),
                {
                  headers: headers,
                }
              )
              .then((res) => {
                if (res.status !== 500 && res.status !== "Failed") {
                  console.log(res);
                  console.log(res.data);
                  if (res.data.txnId !== undefined && res.data.txnId !== null) {
                    toast.success("ABHA Exists to communication Mobile");
                    toast.success(res.data.message);
                    setTxnIdDownload(res.data.txnId);
                    setDisplayDownloadOTPVerify(true);
                    handleVerifyOtpResend();
                  } else if (res.data.loginId === "Invalid LoginId") {
                    toast.error("Please enter a valid mobile number");
                  } else {
                    toast.error(res.data.error.message);
                    setButtonDisabledVerify(false);
                    if (res.data.error.code === "ABDM-1115") {
                      setNavigateToAbha(true);
                    }
                  }
                } else {
                  toast.error("Failed, please try again after sometime!!");
                }
              })
              .catch((err) => {
                console.log(err);
                toast.error(err);
              });

            setPatients([]);
            setPatients(null);
          } else {
            toast.error("Error");
          }
        })
        .catch((error) => {
          console.log("FETCH FAILED");

          console.log(error);
        });
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      getValues("health_id") &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      const requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        loginHint: "aadhaar",
        loginId: getValues("health_id"),
        otpSystem: "aadhaar",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else {
              toast.error(
                res.data.loginId + ". Please provide a valid Aadhaar number."
              );
              setButtonDisabledVerify(false);
              if (res.data.loginId === "Invalid LoginId") {
                setNavigateToAbha(true);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      getValues("health_id") &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      toast.error("Please choose MOBILE_OTP for mobile number");
    } else if (
      auth_mode === "MOBILE_OTP" &&
      getValues("health_id") &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      toast.error("Please choose AADHAAR_OTP for aadhaar number");
    } else if (
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      console.log("inside mobile abha number");
      let healthId = getValues("health_id");

      // Format the healthId if it is a 14-digit number
      if (/^\d{14}$/.test(healthId)) {
        healthId = `${healthId.slice(0, 2)}-${healthId.slice(
          2,
          6
        )}-${healthId.slice(6, 10)}-${healthId.slice(10, 14)}`;
      }
      const requestBody = {
        scope: ["abha-login", "mobile-verify"],
        loginHint: "abha-number",
        loginId: healthId,
        otpSystem: "abdm",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else if (res.data.error) {
              toast.error(res.data.error.message);
            } else {
              toast.error(
                res.data.loginId + ". Please provide a valid ABHA number."
              );
              setButtonDisabledVerify(false);
              if (res.data.loginId === "Invalid LoginId") {
                setNavigateToAbha(true);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else if (
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      console.log("alert data", auth_mode);
      console.log("alert data2", getValues("health_id"));
      console.log("inside aadhar abha number");
      let healthId = getValues("health_id");

      // Format the healthId if it is a 14-digit number
      if (/^\d{14}$/.test(healthId)) {
        healthId = `${healthId.slice(0, 2)}-${healthId.slice(
          2,
          6
        )}-${healthId.slice(6, 10)}-${healthId.slice(10, 14)}`;
      }
      const requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        loginHint: "abha-number",
        loginId: healthId,
        otpSystem: "aadhaar",
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/profile_login_otp_v3/`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else if (res.data.error) {
              toast.error(res.data.error.message);
            } else {
              toast.error(
                res.data.loginId + ". Please provide a valid ABHA number."
              );
              setButtonDisabledVerify(false);
              if (res.data.loginId === "Invalid LoginId") {
                setNavigateToAbha(true);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    } else {
      if (Token()) {
        console.log("alert data", auth_mode);
        console.log("alert data2", getValues("health_id"));
        var post_data = {};
        post_data.abhaAddress = getValues("health_id");
        const alphabetRegex = /[a-zA-Z]/;
        console.log(REACT_APP_SUFFIX, REACT_APP_BACKEND_ROUTE_URL);
        if (alphabetRegex.test(post_data.abhaAddress)) {
          if (!post_data.abhaAddress.endsWith(REACT_APP_SUFFIX)) {
            post_data.abhaAddress += REACT_APP_SUFFIX;
          }
        }
        console.log("post data", post_data);
        const selectedAuthMode = getValues("selected_auth_mode");
        post_data.authMode = selectedAuthMode;
        verifyABHAaddressV3(post_data, undefined);
        // axios
        //   .post(
        //     `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/search_abha_v3/`,
        //     JSON.stringify(post_data),
        //     {
        //       headers: headers,
        //     }
        //   )
        //   .then((res) => {
        //     console.log("API Response:", res.data);
        //     var patientData = patientList.filter(
        //       (item) =>
        //         item.abha_id === res.data.abhaAddress ||
        //         item.abha_no === res.data.healthIdNumber
        //     );

        //     if (res.status !== "" && res.status < 300) {
        //       if (res.data.message) {
        //         toast.error("Cannot process : " + res.data.message);
        //         console.log("Cannot process : " + res.data.message);
        //         setValue("health_id", "");
        //       } else {
        //         const selectedAuthMode = getValues("selected_auth_mode");
        //         let availableAuthMethods = res.data.authMethods || [];

        //         // Update authModes based on available auth methods
        //         if (
        //           availableAuthMethods.includes("MOBILE_OTP") &&
        //           availableAuthMethods.includes("AADHAAR_OTP")
        //         ) {
        //           setAuthModes(["MOBILE_OTP", "AADHAAR_OTP"]); // Case 1
        //         } else if (availableAuthMethods.includes("MOBILE_OTP")) {
        //           setAuthModes(["MOBILE_OTP"]); // Case 2
        //         } else if (availableAuthMethods.includes("AADHAAR_OTP")) {
        //           setAuthModes(["AADHAAR_OTP"]); // Case 3
        //         } else {
        //           setAuthModes([]); // Case 4 (No recognized auth method)
        //         }

        //         console.log("Updated Auth Modes:", authModes);

        //         post_data.authMode = selectedAuthMode;
        //         verifyABHAaddressV3(post_data, undefined);
        //       }
        //     } else {
        //       toast.error("Error : " + (res.data.message || "Unknown error"));
        //     }
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //     toast.error(err.message || "API call failed");
        //   });
      }
    }
  };

  const getProfile = (token) => {
    if (Token()) {
      var post_data = {};
      post_data.token = token;
      post_data.patient_id = taggingPatientId;

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.status !== "" && res.status < 300) {
            if (res.data.code !== undefined && res.data.details !== undefined) {
              if (res.data.details !== null && res.data.details.length > 0) {
                toast.error("Cannot process : " + res.data.message);
              } else {
                if (res.data.patient_id) {
                  console.log("res.data.patient_id", res.data.patient_id);
                  toast.error(
                    `Patient ID already present with this ABHA address ${res.data.patient_id} `
                  );
                }
                //  else if (res.data.patient) {
                //   setMultipleMatchedData(res.data);
                //   toast.error(
                //     "profile does not match! please choose from the cards"
                //   );
                // }
                else if (
                  res.data.patient &&
                  (!res.data.message ||
                    res.data.message !== "Patient updated successfully !!")
                ) {
                  setMultipleMatchedData(res.data);
                  toast.error(
                    "Patient demographics matching with multiple existing patient records.Please choose from the cards."
                  );
                  setTransactionIdForDataVerification(
                    res.data.transaction_id_internal
                  );
                } else if (res.data.message) {
                  toast.success(res.data.message);
                  setHealthIdDetails(res.data);
                } else {
                  setHealthIdDetails(res.data);
                }
              }
            } else {
              if (res.data.patient_id) {
                console.log("res.data.patient_id", res.data.patient_id);
                toast.error(
                  `Patient ID already present with this ABHA address ${res.data.patient_id} `
                );
              }

              // else if (res.data.patient) {
              //   setMultipleMatchedData(res.data);
              //   toast.error(
              //     "profile does not match! please choose from the cards"
              //   );
              // }
              else if (
                res.data.patient &&
                (!res.data.message ||
                  res.data.message !== "Patient updated successfully !!")
              ) {
                setMultipleMatchedData(res.data);
                toast.error(
                  "Patient demographics matching with multiple existing patient records.Please choose from the cards."
                );
                setTransactionIdForDataVerification(
                  res.data.transaction_id_internal
                );
              } else if (res.data.message) {
                toast.success(res.data.message);
              } else {
                setHealthIdDetails(res.data);
              }
            }
            // if (res.data.phrAddress === "") {
            //   setDisplayPatientDetails(true);
            // } else {

            // }
          } else {
            toast.error("Error : " + res.data.message);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };

  const downloadABHAUsingTokenPdf = () => {
    // if (e !== undefined) {
    //   e.preventDefault();
    // }
    var post_data = {};
    // if (tokenForCard && /^\d{12}$/.test(getValues("health_id"))) {
    if (
      tokenForCard &&
      ((Token() && /^\d{10}$/.test(getValues("health_id"))) ||
        /^\d{12}$/.test(getValues("health_id")) ||
        (getValues("health_id") &&
          (/^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id")) ||
            /^\d{14}$/.test(getValues("health_id")))))
    ) {
      console.log(tokenForCard);
      post_data.token = tokenForCard;
      //ChangeCursor();
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_abha_card_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            var blob = b64toBlob(res.data.value, "image/png");
            const url = window.URL.createObjectURL(blob);
            const pdfWindow = window.open("");
            pdfWindow.document.write(
              "<img width='100%' height='100%' src='" + url + "'></img>"
            );
          } else {
            toast.error(
              "ABHA Download Failed, please try again after sometime!!"
            );
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (tokenForCard) {
      console.log(tokenForCard);
      post_data.token = tokenForCard;
      //ChangeCursor();
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/phr_card_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          // if (res.status !== 500 && res.status !== "Failed") {
          //   console.log(res);
          //   console.log(res.data);
          //   var blob = b64toBlob(res.data.value, "application/pdf");
          //   const url = window.URL.createObjectURL(blob, {
          //     type: "application/pdf",
          //   });
          //   const pdfWindow = window.open("");
          //   pdfWindow.document.write(
          //     "<iframe width='100%' height='100%' src='" + url + "'></iframe>"
          //   );
          // } else {
          //   toast.error(
          //     "ABHA Download Failed, please try again after sometime!!"
          //   );
          // }
          if (res?.data?.message?.includes("non-KYC ABHA address")) {
            toast.error(res.data.message);
          } else if (res.status !== 500) {
            console.log(res);
            console.log(res.data);
            var blob = b64toBlob(res.data.value, "image/png");
            const url = window.URL.createObjectURL(blob);
            const pdfWindow = window.open("");
            pdfWindow.document.write(
              "<img width='100%' height='100%' src='" + url + "'></img>"
            );
          } else {
            toast.error(
              "ABHA Download Failed, please try again after sometime!!"
            );
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };

  const handleVerifyOtpResend = () => {
    // console.log("currentCount", otpResendCount);
    if (otpResendCount <= 3) {
      setOtpResendCount((prevCount) => prevCount + 1);
      setButtonDisabledVerify(true);

      if (otpResendCount < 2) {
        setTimeout(() => {
          setButtonDisabledVerify(false);
        }, RESEND_OTP_TIMER);
      }
    } else {
      toast.error(
        "You have reached the maximum number of resend attempts. Please try again later."
      );
    }
  };

  const verifyABHAaddressV3 = (data) => {
    var post_data = {};
    if (Token()) {
      console.log(data);

      if (data.authMode === "MOBILE_OTP") {
        post_data.scope = ["abha-address-login", "mobile-verify"];
        post_data.loginHint = "abha-address";
        post_data.loginId = data.abhaAddress;
        post_data.otpSystem = "abdm";
      } else if (data.authMode === "AADHAAR_OTP") {
        post_data.scope = ["abha-address-login", "aadhaar-verify"];
        post_data.loginHint = "abha-address";
        post_data.loginId = data.abhaAddress;
        post_data.otpSystem = "aadhaar";
      }

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/login_abha_otp_v3/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.txnId !== undefined && res.data.txnId !== null) {
              setTxnIdDownload(res.data.txnId);
              setDisplayDownloadOTPVerify(true);
              handleVerifyOtpResend();
              toast.success(res.data.message);
            } else {
              if (
                res.data.details !== undefined &&
                res.data.details !== null &&
                res.data.details.length > 0
              ) {
                toast.error("Error while fetching : " + res.data.message);
                toast.error("Error Message : " + res.data.details[0].message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };

  const fetchDetailsFromOTP = (data, e) => {
    e.preventDefault();
    const auth_mode = getValues("selected_auth_mode");
    //ChangeCursor();
    var post_data = {};
    if (
      Token() &&
      auth_mode === "MOBILE_OTP" &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      verifyOtpV3(data);
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      verifyOtpV3(data);
    } else if (
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      verifyOtpV3(data);
    } else if (
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      verifyOtpV3(data);
    } else {
      verifyOtpV3(data);
      // console.log("non v3");
      // post_data.txnId = txnIdDownload;
      // post_data.otp = getValues8("abha_id_otp");
      // const auth_mode = getValues("selected_auth_mode");
      // var endpoint = "";
      // if (auth_mode === "AADHAAR_OTP") {
      //   endpoint = "health_id_login_confirm_with_aadhaar_otp";
      // } else {
      //   endpoint = "health_id_login_confirm_with_mobile_otp";
      // }
      // axios
      //   .post(
      //     `${REACT_APP_BACKEND_ROUTE_URL}health_id/${endpoint}/`,
      //     JSON.stringify(post_data),
      //     {
      //       headers: headers,
      //     }
      //   )
      //   .then((res) => {
      //     if (res.status !== 500 && res.status !== "Failed") {
      //       console.log(res);
      //       console.log(res.data);
      //       if (res.data.token !== undefined && res.data.token !== null) {
      //         var post_data_for_card = {};
      //         post_data_for_card.token = res.data.token;
      //         post_data_for_card.patient_id = taggingPatientId;
      //         if (displayDownloadOTPVerify === true) {
      //           getProfile(res.data.token);
      //           setTokenForCard(res.data.token);
      //           setOtpResendCount(0);
      //           setDissableAllButtonsVerify(true);
      //         } else {
      //           axios
      //             .post(
      //               `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
      //               JSON.stringify(post_data_for_card),
      //               {
      //                 headers: headers,
      //               }
      //             )
      //             .then((res) => {
      //               if (res.status !== 500 && res.status !== "Failed") {
      //                 console.log(res.data);
      //                 setPatientDetails(res.data);
      //               }
      //             })
      //             .catch((err) => {
      //               console.log(err);
      //             });
      //         }
      //       } else {
      //         if (
      //           res.data.details !== undefined &&
      //           res.data.details !== null &&
      //           res.data.details.length > 0
      //         ) {
      //           // toast.error("Error while fetching : " + res.data.message);
      //           toast.error("Error Message : " + res.data.details[0].message);
      //         }
      //       }
      //     } else {
      //       toast.error("Failed, please try again after sometime!!");
      //     }
      //     //ChangeCursor();
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     toast.error(err);
      //     //ChangeCursor();
      //   });
    }
  };
  const verifyOtpV3 = (data) => {
    const auth_mode = getValues("selected_auth_mode");
    let endpoint = "";
    let requestBody = {};

    if (
      auth_mode === "MOBILE_OTP" &&
      getValues("health_id") &&
      /^\d{10}$/.test(getValues("health_id"))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "mobile-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);

            if (res.data.token !== undefined && res.data.token !== null) {
              toast.success(res.data.message);
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                setTokenForCard(res.data.token);
                setTxnIdV3(res.data.txnId);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                if (res.data.accounts && Array.isArray(res.data.accounts)) {
                  setAccounts(res.data.accounts);
                }
                setNavigateToAbha(false);
              } else {
                // axios
                //   .post(
                //     `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
                //     JSON.stringify(post_data_for_card),
                //     {
                //       headers: headers,
                //     }
                //   )
                //   .then((res) => {
                //     if (res.status !== 500 && res.status !== "Failed") {
                //       console.log(res.data);
                //       setPatientDetails(res.data);
                //     }
                //   })
                //   .catch((err) => {
                //     console.log(err);
                //   });
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.message) {
                toast.error(res.data.message);
              } else {
                toast.error(res.data.otpValue);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (
      auth_mode === "AADHAAR_OTP" &&
      getValues("health_id") &&
      /^\d{12}$/.test(getValues("health_id"))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                toast.success(res.data.message);
                setTokenForCard(res.data.token);
                getProfileV3(res.data.token);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                setNavigateToAbha(false);
              } else {
                // axios
                //   .post(
                //     `${REACT_APP_BACKEND_ROUTE_URL}health_id_x_token/get_profile/`,
                //     JSON.stringify(post_data_for_card),
                //     {
                //       headers: headers,
                //     }
                //   )
                //   .then((res) => {
                //     if (res.status !== 500 && res.status !== "Failed") {
                //       console.log(res.data);
                //       setPatientDetails(res.data);
                //     }
                //   })
                //   .catch((err) => {
                //     console.log(err);
                //   });
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.error) {
                toast.error(res.data.error.message);
                setNavigateToAbha(true);
              } else if (res.data.otpValue) {
                toast.error(res.data.otpValue);
              } else {
                toast.error(res.data.message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "MOBILE_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "mobile-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                toast.success(res.data.message);
                setTokenForCard(res.data.token);
                getProfileV3(res.data.token);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                setNavigateToAbha(false);
              } else {
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.error) {
                toast.error(res.data.error.message);
                setNavigateToAbha(true);
              } else if (res.data.otpValue) {
                toast.error(res.data.otpValue);
              } else {
                toast.error(res.data.message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else if (
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{2}-\d{4}-\d{4}-\d{4}$/.test(getValues("health_id"))) ||
      (auth_mode === "AADHAAR_OTP" &&
        getValues("health_id") &&
        /^\d{14}$/.test(getValues("health_id")))
    ) {
      endpoint = "abha_v3/profile_verify_otp_v3/";
      requestBody = {
        scope: ["abha-login", "aadhaar-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            txnId: txnIdDownload,
            otpValue: getValues8("abha_id_otp"),
          },
        },
      };
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
          JSON.stringify(requestBody),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status !== 500 && res.status !== "Failed") {
            console.log(res);
            console.log(res.data);
            if (res.data.token !== undefined && res.data.token !== null) {
              var post_data_for_card = {};
              post_data_for_card.token = res.data.token;
              if (displayDownloadOTPVerify === true) {
                toast.success(res.data.message);
                setTokenForCard(res.data.token);
                getProfileV3(res.data.token);
                setOtpResendCount(0);
                setDissableAllButtonsVerify(true);
                setNavigateToAbha(false);
              } else {
                console.log("displayDownloadOTPVerify is not true");
              }
            } else {
              if (res.data.error) {
                toast.error(res.data.error.message);
                setNavigateToAbha(true);
              } else if (res.data.otpValue) {
                toast.error(res.data.otpValue);
              } else {
                toast.error(res.data.message);
              }
            }
          } else {
            toast.error("Failed, please try again after sometime!!");
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    } else {
      if (auth_mode === "AADHAAR_OTP") {
        endpoint = "abha_v3/verify_abha_otp_v3/";
        requestBody = {
          scope: ["abha-address-login", "aadhaar-verify"],
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: txnIdDownload,
              otpValue: getValues8("abha_id_otp"),
            },
          },
        };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
            JSON.stringify(requestBody),
            {
              headers: headers,
            }
          )
          .then((res) => {
            if (res.status !== 500 && res.status !== "Failed") {
              console.log(res);
              console.log(res.data);
              if (
                res.data.message === "OTP verified successfully" &&
                res.data.tokens.token !== null
              ) {
                var post_data_for_card = {};
                post_data_for_card.token = res.data.tokens.token;
                if (displayDownloadOTPVerify === true) {
                  toast.success(res.data.message);

                  // getProfileV3(res.data.tokens.token);
                  getProfileV3AbhaAddress(res.data.tokens.token);
                  setTokenForCard(res.data.tokens.token);

                  setOtpResendCount(0);
                  setDissableAllButtonsVerify(true);
                  setNavigateToAbha(false);
                } else {
                  console.log("displayDownloadOTPVerify is not true");
                }
              } else {
                if (res.data.error) {
                  toast.error(res.data.error.message);
                  setNavigateToAbha(true);
                } else if (
                  (Array.isArray(res.data)
                    ? res.data[0]?.message
                    : res.data.message) === "Invalid OTP Request"
                ) {
                  toast.error(
                    Array.isArray(res.data)
                      ? res.data[0]?.message
                      : res.data.message
                  );
                } else if (res.data.otpValue) {
                  toast.error(res.data.otpValue);
                } else {
                  toast.error(res.data.message);
                }
              }
            } else {
              toast.error("Failed, please try again after sometime!!");
            }
            //ChangeCursor();
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
            //ChangeCursor();
          });
      } else if (auth_mode === "MOBILE_OTP") {
        endpoint = "abha_v3/verify_abha_otp_v3/";
        requestBody = {
          scope: ["abha-address-login", "mobile-verify"],
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: txnIdDownload,
              otpValue: getValues8("abha_id_otp"),
            },
          },
        };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}${endpoint}`,
            JSON.stringify(requestBody),
            {
              headers: headers,
            }
          )
          .then((res) => {
            if (res.status !== 500 && res.status !== "Failed") {
              console.log(res);
              console.log(res.data);
              if (
                res.data.message === "OTP verified successfully" &&
                res.data.tokens.token !== null
              ) {
                var post_data_for_card = {};
                post_data_for_card.token = res.data.tokens.token;
                if (displayDownloadOTPVerify === true) {
                  toast.success(res.data.message);
                  setTokenForCard(res.data.tokens.token);
                  getProfileV3AbhaAddress(res.data.tokens.token);
                  // getProfileV3(res.data.tokens.token);
                  setOtpResendCount(0);
                  setDissableAllButtonsVerify(true);
                  setNavigateToAbha(false);
                } else {
                  console.log("displayDownloadOTPVerify is not true");
                }
              } else {
                if (res.data.error) {
                  toast.error(res.data.error.message);
                  setNavigateToAbha(true);
                } else if (
                  (Array.isArray(res.data)
                    ? res.data[0]?.message
                    : res.data.message) === "Invalid OTP Request"
                ) {
                  toast.error(
                    Array.isArray(res.data)
                      ? res.data[0]?.message
                      : res.data.message
                  );
                } else if (res.data.otpValue) {
                  toast.error(res.data.otpValue);
                } else {
                  toast.error(res.data.message);
                }
              }
            } else {
              toast.error("Failed, please try again after sometime!!");
            }
            //ChangeCursor();
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
            //ChangeCursor();
          });
      }
    }
  };

  const getProfileV3 = (token) => {
    const requestBody = {
      token: token,
      patient_id: taggingPatientId,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_profile_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status !== 500 && response.status !== "Failed") {
          console.log("Profile Data:", response.data);
          if (response.data.patient_id) {
            console.log("response.data.patient_id", response.data.patient_id);
            toast.error(
              `Patient ID already present with this ABHA address ${response.data.patient_id} `
            );
          }
          //  else if (response.data.patient) {
          //   setMultipleMatchedData(response.data);
          //   toast.error("profile does not match! please choose from the cards");
          // }
          else if (
            response.data.patient &&
            (!response.data.message ||
              response.data.message !== "Patient updated successfully !!")
          ) {
            setMultipleMatchedData(response.data);
            toast.error(
              "Patient demographics matching with multiple existing patient records.Please choose from the cards."
            );
            setTransactionIdForDataVerification(
              response.data.transaction_id_internal
            );
            console.log(
              "transaction_id_internal inside",
              response.data.transaction_id_internal
            );
          } else if (response.data.message) {
            toast.success(response.data.message);
            setHealthIdDetails(response.data);
          } else {
            setHealthIdDetails(response.data);
          }
        } else {
          toast.error("Failed to fetch profile, please try again later!!");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const getProfileV3AbhaAddress = (token) => {
    const requestBody = {
      token: token,
      patient_id: taggingPatientId,
    };

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/abha_profile_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status !== 500 && response.status !== "Failed") {
          console.log("Profile Data:", response.data);
          if (response.data.patient_id) {
            console.log("response.data.patient_id", response.data.patient_id);
            toast.error(
              `Patient ID already present with this ABHA address ${response.data.patient_id} `
            );
          }
          //  else if (response.data.patient) {
          //   setMultipleMatchedData(response.data);
          //   toast.error("profile does not match! please choose from the cards");
          // }
          else if (
            response.data.patient &&
            (!response.data.message ||
              response.data.message !== "Patient updated successfully !!")
          ) {
            setMultipleMatchedData(response.data);
            toast.error(
              "Patient demographics matching with multiple existing patient records.Please choose from the cards."
            );
            setTransactionIdForDataVerification(
              response.data.transaction_id_internal
            );
            console.log(
              "transaction_id_internal inside",
              response.data.transaction_id_internal
            );
          } else if (response.data.message) {
            toast.success(response.data.message);
            setHealthIdDetails(response.data);
          } else {
            setHealthIdDetails(response.data);
          }
        } else {
          toast.error("Failed to fetch profile, please try again later!!");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const onSubmitAccount = (data) => {
    console.log("Selected Account:", selectedABHANumber);
    console.log("txnIdV3:", txnIdV3);
    const requestBody = {
      ABHANumber: selectedABHANumber,
      txnId: txnIdV3,
      token: tokenForCard,
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/verify_user_v3/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status !== 500 && response.status !== "Failed") {
          setTokenForCardV3(response.data.token);
          getProfileV3(response.data.token);
          setIsCardSelectionFrozen(true);
        } else {
          toast.error("Failed to fetch profile, please try again later!!");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.message);
      });
  };

  const handleCardSelect = (abhaNumber) => {
    setSelectedABHANumber(abhaNumber);
  };
  const downloadABHAUsingTokenPdfV3 = () => {
    console.log("inside v3card download");
    const post_data_for_card = {
      token: tokenForCardV3,
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}abha_v3/get_abha_card_v3/`,
        JSON.stringify(post_data_for_card),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.status !== 500 && res.status !== "Failed") {
          console.log(res);
          console.log(res.data);
          var blob = b64toBlob(res.data.value, "image/png");
          const url = window.URL.createObjectURL(blob);
          const pdfWindow = window.open("");
          pdfWindow.document.write(
            "<img width='100%' height='100%' src='" + url + "'></img>"
          );
        } else {
          toast.error(
            "ABHA Download Failed, please try again after sometime!!"
          );
        }
        //ChangeCursor();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
        //ChangeCursor();
      });
  };

  var b64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const handleCardSelectSearch = (patId) => {
    setselectedPatId(patId);
    const matchedPatient = patients.find(
      (patient) => patient.patient_id === patId
    );
    if (matchedPatient) {
      setPatientForMobileSearch(matchedPatient);
      setPatientData(matchedPatient);
    } else {
      console.log("No matching patient found for the given ID.");
    }
    console.log("id for search patId", patId);
  };

  const handleAddNewPatient = () => {
    const matchedData = multipleMatchedData;
    handleCloseVerifyModal();
    resetForm();
    setSelectedPartiallyMatchedPatient(matchedData);
    console.log("Adding new patient :", matchedData);
  };

  const handleUpdatePatient = (patientId) => {
    const patient = multipleMatchedData.patient.find(
      (p) => p.patient_id === patientId
    );
    // Logic to update the patient
    resetForm();
    console.log("Updating patient with ID:", patient);

    const formattedMonth = multipleMatchedData.monthOfBirth
      ? String(multipleMatchedData.monthOfBirth).padStart(2, "0")
      : "";
    const formattedDay = multipleMatchedData.dayOfBirth
      ? String(multipleMatchedData.dayOfBirth).padStart(2, "0")
      : "";
    const formattedDateOfBirth = multipleMatchedData.yearOfBirth
      ? `${multipleMatchedData.yearOfBirth}-${formattedMonth}-${formattedDay}`
      : null;

    const abhaId =
      multipleMatchedData.abhaAddress ||
      multipleMatchedData.preferredAbhaAddress ||
      multipleMatchedData.healthId ||
      patient.abha_id;

    const abhaNo =
      multipleMatchedData.abhaNumber ||
      multipleMatchedData.ABHANumber ||
      multipleMatchedData.healthIdNumber ||
      patient.abha_no;

    const fullName = multipleMatchedData.name || multipleMatchedData.fullName;

    const mergedData = {
      patient_id: patient.patient_id,
      name: fullName || patient.name,
      first_name: multipleMatchedData.firstName || patient.first_name,
      middle_name: multipleMatchedData.middleName || patient.middle_name,
      last_name: multipleMatchedData.lastName || patient.last_name,
      abha_id: abhaId,
      abha_no: abhaNo,
      gender: multipleMatchedData.gender || patient.gender,
      email: multipleMatchedData.email || patient.email,
      pincode:
        multipleMatchedData.pincode ||
        multipleMatchedData.pinCode ||
        patient.pincode,
      city: multipleMatchedData.townName || patient.city,
      state: multipleMatchedData.stateName || patient.state,
      district: multipleMatchedData.districtName || patient.district,
      address_line: multipleMatchedData.address || patient.address_line,
      age: multipleMatchedData.age || patient.age,
      dob: formattedDateOfBirth,
      phone_no: multipleMatchedData.mobile || patient.phone_no,
      photo: multipleMatchedData.profilePhoto || patient.photo,
      height: multipleMatchedData.height || patient.height,
      weight: multipleMatchedData.weight || patient.weight,
      health_insurance: patient.health_insurance,
      facility: patient.facility,
    };

    console.log("mergedData", mergedData);
    setPatientData(mergedData);
    handleCloseVerifyModal();
  };

  const handleCancelUpdate = (patientId) => {
    // Logic to cancel the update
    console.log("Cancelling update for patient with ID:", patientId);
    handleCloseVerifyModal();
  };

  const handleCardSelectUpdate = (patientId) => {
    setActivePatientId(patientId);
    console.log("Active patient selected:", patientId);
  };

  return (
    <>
        <Modal
          show={showVerifyModal}
          onHide={handleCloseVerifyModal}
          onExited={handleVerifyModalExited}
          centered
          backdrop="static"
          className="register-modal"
          style={{ zIndex: 9997 }}
        >
          {/* <Modal.Header
            closeButton
            style={{
              backgroundImage: `url(${Icons.modal_blue})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
           <button
              type="button"
              onClick={handleCloseVerifyModal}
              aria-label="Close"
              style={{
                WebkitMaskImage:
                  "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586l6.293-6.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\")",
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                WebkitMaskSize: "contain",
                backgroundColor: "white", // makes the "X" white
                width: "1 rem",
                height: "1 rem",
                border: "none",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "1.5rem",
                cursor: "pointer",
              }}
            />
            <Modal.Title>Verify ABHA</Modal.Title>
          </Modal.Header> */}
          <Modal.Header
            style={{
              // backgroundImage: `url(${Icons.modal_blue})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              color: "white",
              display: "flex",
              justifyContent: "space-between", // pushes title left, button right
              alignItems: "center",
              backgroundColor:"#213360"
            }}
          >
            <Modal.Title  className="main-title" style={{ margin: 0 ,color: "#FFFFFF"}}>Verify ABHA</Modal.Title>

            <button
              type="button"
              onClick={handleCloseVerifyModal}
              aria-label="Close"
              style={{
                WebkitMaskImage:
                  "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586l6.293-6.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\")",
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                WebkitMaskSize: "contain",
                backgroundColor: "white", // makes the "X" white
                width: "1rem",
                height: "1rem",
                border: "none",
                cursor: "pointer",
              }}
            />
          </Modal.Header>

          <Modal.Body style={{ overflowY: "auto" }}>
            <div>
              {/* <h1 style={{ textAlign: "center" }}>Verify ABHA</h1> */}
              <div className="contact-panel mb-50">
                <form
                  className="contact-panel__form"
                  onSubmit={handleSubmit(submit)}
                >
                  <div className="row">
                    {navigateToAbha && (
                      <>
                        <div className="col-sm-6 col-md-6 col-lg-6"></div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <Link
                            href="#"
                            onClick={handleLinkToGenerateAbha}
                            className="hyperlink"
                            style={{ marginLeft: "10px" }}
                          >
                            Click here to generate ABHA
                          </Link>
                        </div>
                      </>
                    )}

                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="form-group">
                        <i className="icon-news form-group-icon"></i>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter ABHA Address / Mobile no /Aadhaar no / ABHA Number"
                          name="health_id"
                          disabled={
                            displayDownloadOTPVerify || disableForMobileVerify
                          }
                          {...register("health_id", {
                            required:
                              "ABHA Address / Mobile no /Aadhaar no / ABHA Number is required ",
                            pattern: {
                              // value:
                              //   /^(?:\d{10}|\d{12}|\d{14}|\d{2}-\d{4}-\d{4}-\d{4}|[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+${REACT_APP_SUFFIX})$/,
                              value: new RegExp(
                                `^(?:\\d{10}|\\d{12}|\\d{14}|\\d{2}-\\d{4}-\\d{4}-\\d{4}|[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':"\\\\|,.<>\\/?]+${REACT_APP_SUFFIX})$`
                              ),
                              message:
                                "Invalid format. Please enter a valid ABHA Address / Mobile no / Aadhaar no / ABHA Number",
                            },
                            // minLength: {
                            //   value: 4,
                            //   message: "Minimum Length is 4.",
                            // },
                          })}
                        />
                        {errors.health_id && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.health_id.message}
                          </p>
                        )}
                      </div>
                    </div>
                    {patients && patients.length === 0 && (
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                          <i className="icon-user form-group-icon"></i>
                          <select
                            // disabled={isSelectDisabled}
                            className="form-control"
                            name="selected_auth_mode"
                            {...register("selected_auth_mode", {
                              required: "Auth Method is required.",
                            })}
                          >
                            {authModes.map((item, index) => (
                              <option value={item}>{item}</option>
                            ))}
                          </select>
                          {errors.selected_auth_mode && (
                            <p className="errorMsg" style={{ color: "red" }}>
                              {errors.selected_auth_mode.message}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    {/* <div className="col-sm-12 col-md-12 col-lg-12">
                      <button
                        disabled={buttonDisabledVerify}
                        type="submit"
                        id="check_health_id"
                        className="btn btn__secondary btn__rounded btn__block mt-6"
                      >
                        <span>
                          {displayDownloadOTPVerify ? "Resend OTP" : "Search"}
                        </span>{" "}
                        <i className="icon-arrow-right"></i>
                      </button>
                    </div>
                    <div className="contact-result">
                      {buttonDisabledVerify && displayDownloadOTPVerify && (
                        <ResendOtpTimer />
                      )}
                    </div> */}
                    {isContinueButtonClicked ? (
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <button
                          disabled={true}
                          type="submit"
                          id="check_health_id"
                          className="btn btn__secondary btn__rounded btn__block mt-6"
                        >
                          <span>{"Search"}</span>
                          <i className="icon-arrow-right"></i>
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <button
                          disabled={
                            buttonDisabledVerify || dissableAllButtonsVerify
                          }
                          type="submit"
                          id="check_health_id"
                          className="btn btn__secondary btn__rounded btn__block mt-6"
                        >
                          <span>
                            {displayDownloadOTPVerify ? "Resend OTP" : "Search"}
                          </span>
                          {/* {buttonDisabledVerify && (
                          <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                        )} */}
                          {buttonDisabledVerify &&
                            otpResendCount < 3 &&
                            otpResendCount > 0 && (
                              <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                            )}

                          <i className="icon-arrow-right"></i>
                        </button>
                      </div>
                    )}

                    {/* <div className="contact-result">
                      {buttonDisabledVerify && (
                        <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                      )}
                    </div> */}
                  </div>
                </form>

                {patients && patients.length > 0 && (
                  <form onSubmit={handleSubmit13(onSubmitAccountMobile)}>
                    <Typography
                      variant="h6"
                      style={{ marginBottom: "20px", textAlign: "center" }}
                    >
                      Patients From The Facility
                    </Typography>
                    <Grid container spacing={2}>
                      {/* {patients.map((patient, index) => (
                        <Grid item xs={12} sm={12} key={index}>
                          <Card
                            style={{
                              marginBottom: "20px",
                              border:
                                selectedPatId === patient.patient_id
                                  ? "2px solid blue"
                                  : "none",
                              height: "300px",
                            }}
                            // onClick={() =>
                            //   handleCardSelectSearch(patient.patient_id)
                            // }
                          >
                            <CardContent>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Avatar
                                  alt={displayPatientName(patient.name)}
                                  src={normalizeBase64Image(patient.photo)}
                                  style={{ marginRight: "20px" }}
                                />
                                <div>
                                  <Typography variant="h6">
                                    {displayPatientName(patient.name)}
                                  </Typography>
                                  <Typography variant="body2">
                                    ABHA Number: {patient.abha_no || "-"}
                                  </Typography>
                                  <Typography variant="body2">
                                    patient ID: {patient.patient_id}
                                  </Typography>
                                  <Typography variant="body2">
                                    ABHA Address: {patient.abha_id || "-"}
                                  </Typography>
                                  <Typography variant="body2">
                                    Gender: {patient.gender}
                                  </Typography>
                                  <Typography variant="body2">
                                    DOB: {patient.dob}
                                  </Typography>
                                </div>
                              </div>
                              <div style={{ marginTop: "10px" }}>
                                <Link
                                  href="#"
                                  onClick={() =>
                                    handleCardSelectSearch(patient.patient_id)
                                  }
                                  className="hyperlink"
                                >
                                  Revisit Details
                                </Link>
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))} */}
                      {patients.map((patient, index) => (
                        <Grid item xs={12} key={index}>
                          <Card
                            style={{
                              marginBottom: "20px",
                              border:
                                selectedPatId === patient.patient_id
                                ? "2px solid #21cdc0"
                                  : "none",
                              height: "220px", // keep consistent height
                              display: "flex",
                            }}
                          >
                            <CardContent
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between", // pushes button down
                                width: "100%",
                              }}
                            >
                              {/* Top Section: Avatar + Details */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Avatar
                                  alt={displayPatientName(patient.name)}
                                  src={normalizeBase64Image(patient.photo)}
                                  style={{
                                    marginRight: "20px",
                                    width: 64,
                                    height: 64,
                                  }}
                                />
                                <div>
                                  <Typography
                                    variant="subtitle1"
                                    style={{
                                      fontWeight: "bold",
                                      color: "#1a237e",
                                      textTransform: "uppercase"
                                    }}
                                  >
                                    {displayPatientName(patient.name)}
                                  </Typography>
                                  <Typography variant="body2">
                                    ABHA Number: {patient.abha_no || "-"}
                                  </Typography>
                                  <Typography variant="body2">
                                    patient ID: {patient.patient_id}
                                  </Typography>
                                  <Typography variant="body2">
                                    ABHA Address: {patient.abha_id || "-"}
                                  </Typography>
                                  <Typography variant="body2">
                                    Gender: {patient.gender}
                                  </Typography>
                                  <Typography variant="body2">
                                    DOB: {patient.dob}
                                  </Typography>
                                </div>
                              </div>

                              {/* Bottom Right Button */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Link
                                  href="#"
                                  onClick={() =>
                                    handleCardSelectSearch(patient.patient_id)
                                  }
                                  style={{
                                    textDecoration: "none",
                                    padding: "6px 12px",
                                    border: "1px solid #21cdc0",
                                    borderRadius: "6px",
                                    color: "#21cdc0",
                                    fontWeight: "500",
                                    fontSize: "0.875rem",
                                    transition: "0.3s",
                                  }}
                                >
                                  Revisit Details
                                </Link>
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                    <div style={{ textAlign: "center", margin: "20px 0" }}>
                      <Typography variant="h6">OR</Typography>
                    </div>
                  </form>
                )}
                {continueWithMobileVerification ? (
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <button
                        type="button"
                        className="btn btn__secondary btn__block btn__rounded mt-6"
                        onClick={handleContinueWithMobileVerification}
                        disabled={isContinueButtonClicked}
                      >
                        <span>Continue with ABHA Verification With OTP</span>{" "}
                        <i className="icon-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                ) : (
                  []
                )}

                {continueWithMobileVerificationVisible ? (
                  <form
                    className="contact-panel__form"
                    style={{ paddingTop: "5%" }}
                    onSubmit={handleSubmit14(resendMobileVerifictionOfABHA)}
                  >
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <button
                          disabled={
                            buttonDisabledContinueForMobile ||
                            dissableAllButtonsVerify
                          }
                          type="submit"
                          id="check_health_id"
                          className="btn btn__secondary btn__rounded btn__block mt-6"
                        >
                          <span>
                            {/* {displayDownloadOTPVerify ? "Resend OTP" : "Search"} */}
                            Resend OTP
                          </span>
                          {/* {buttonDisabledVerify && (
                          <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                        )} */}
                          {buttonDisabledContinueForMobile &&
                            otpResendCountVerifyForMobile < 3 &&
                            otpResendCountVerifyForMobile > 0 && (
                              <ResendOtpTimer duration={RESEND_OTP_TIMER} />
                            )}

                          <i className="icon-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                ) : (
                  []
                )}
                {displayDownloadOTPVerify ? (
                  <form
                    className="contact-panel__form"
                    style={{ paddingTop: "5%" }}
                    onSubmit={handleSubmit8(fetchDetailsFromOTP)}
                  >
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <div className="form-group">
                          <i className="icon-news form-group-icon"></i>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            name="abha_id_otp"
                            {...register8("abha_id_otp", {
                              required: "OTP is required.",
                            })}
                          />
                          {errors8.abha_id_otp && (
                            <p className="errorMsg" style={{ color: "red" }}>
                              {errors8.abha_id_otp.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <button
                          type="submit"
                          id="check_health_id"
                          className="btn btn__secondary btn__block btn__rounded mt-6"
                          disabled={dissableAllButtonsVerify}
                        >
                          <span>Verify OTP</span>{" "}
                          <i className="icon-arrow-right"></i>
                        </button>
                        <div className="contact-result"></div>
                      </div>
                    </div>
                  </form>
                ) : (
                  []
                )}
                {tokenForCard && !/^\d{10}$/.test(getValues("health_id")) && (
                  <button
                    type="button"
                    id="check_health_card"
                    className={`btn btn__secondary btn__block btn__rounded mt-6`}
                    onClick={downloadABHAUsingTokenPdf}
                  >
                    <span>Download ABHA CARD</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                )}
              </div>
            </div>
            {accounts && accounts.length > 0 && (
              <form onSubmit={handleSubmit12(onSubmitAccount)}>
                <Typography
                  variant="h6"
                  style={{ marginBottom: "20px", textAlign: "center" }}
                >
                  Choose a Profile
                </Typography>
                <Grid container spacing={2}>
                  {/* {accounts.map((account, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Card
                        style={{
                          marginBottom: "20px",
                          border:
                            selectedABHANumber === account.ABHANumber
                              ? "2px solid blue"
                              : "none", // Example: Highlight selected card
                        }}
                        onClick={() => handleCardSelect(account.ABHANumber)} // Select card on click
                      >
                        <CardContent>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Avatar
                              alt={account.name}
                              src={`data:image/jpeg;base64,${account.profilePhoto}`}
                              style={{ marginRight: "20px" }}
                            />
                            <div>
                              <Typography variant="h6">
                                {account.name}
                              </Typography>
                              <Typography variant="body2">
                                ABHA Number: {account.ABHANumber}
                              </Typography>
                              <Typography variant="body2">
                                ABHA Address: {account.preferredAbhaAddress}
                              </Typography>
                              <Typography variant="body2">
                                Gender:{" "}
                                {account.gender === "M" ? "Male" : "Female"}
                              </Typography>
                              <Typography variant="body2">
                                DOB: {account.dob}
                              </Typography>
                              <Typography variant="body2">
                                Status: {account.status}
                              </Typography>
                              <Typography variant="body2">
                                KYC Verified:{" "}
                                {account.kycVerified ? "Yes" : "No"}
                              </Typography>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))} */}
                  {accounts.map((account, index) => (
                    <Grid item xs={12} key={index}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center", // centers horizontally
                        }}
                      >
                        <Card
                          style={{
                            border:
                              selectedABHANumber === account.ABHANumber
                                 ? "2px solid #21cdc0"
                                : "none",
                            borderRadius: "34px",
                            height: "220px", // consistent height
                            width: "87%", // controlled width
                            marginBottom: "20px",
                            display: "flex",
                          }}
                          onClick={() => handleCardSelect(account.ABHANumber)}
                        >
                          <CardContent
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            {/* Avatar + Details */}
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Avatar
                                alt={account.name}
                                src={`data:image/jpeg;base64,${account.profilePhoto}`}
                                style={{
                                  marginRight: "20px",
                                  width: 64,
                                  height: 64,
                                  backgroundColor: "#e0e0e0",
                                }}
                              />
                              <div>
                                <Typography
                                  variant="subtitle1"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#1a237e",
                                  }}
                                >
                                  {account.name}
                                </Typography>
                                <Typography variant="body2">
                                  ABHA Number: {account.ABHANumber}
                                </Typography>
                                <Typography variant="body2">
                                  ABHA Address: {account.preferredAbhaAddress}
                                </Typography>
                                <Typography variant="body2">
                                  Gender:{" "}
                                  {account.gender === "M" ? "Male" : "Female"}
                                </Typography>
                                <Typography variant="body2">
                                  DOB: {account.dob}
                                </Typography>
                                <Typography variant="body2">
                                  Status: {account.status}
                                </Typography>
                                <Typography variant="body2">
                                  KYC Verified:{" "}
                                  {account.kycVerified ? "Yes" : "No"}
                                </Typography>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      </Box>
                    </Grid>
                  ))}
                </Grid>

                <button
                  type="submit"
                  className="btn btn__secondary btn__block btn__rounded mt-12 centered-button"
                  disabled={!selectedABHANumber || isCardSelectionFrozen}
                >
                  <span>Submit</span> <i className="icon-arrow-right"></i>
                </button>
                <div className="contact-result"></div>
              </form>
            )}

            {tokenForCardV3 && (
              <button
                type="button"
                id="check_health_card"
                className={`btn btn__secondary btn__block btn__rounded mt-6`}
                onClick={downloadABHAUsingTokenPdfV3}
                style={{ marginTop: "20px" }}
              >
                <span>Download ABHA CARD</span>{" "}
                <i className="icon-arrow-right"></i>
              </button>
            )}

            {/* {multipleMatchedData &&
              multipleMatchedData.patient &&
              multipleMatchedData.patient.length > 0 && (
                <Box
                  sx={{
                    height: "600px",
                    overflow: "auto",
                    padding: "16px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                  }}
                >
                  <form>
                    <Typography
                      variant="h6"
                      style={{ marginBottom: "20px", textAlign: "center" }}
                    >
                    Matched Profiles
                    </Typography>
                    <Grid container spacing={2}>
                      {multipleMatchedData.patient.map((patient, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <Card
                            sx={{
                              minHeight: "200px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <CardContent
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                height: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    alt={displayPatientName(patient.name)}
                                    src={`data:image/jpeg;base64,${patient.photo}`}
                                    style={{ marginRight: "20px" }}
                                  />
                                  <div>
                                    <Typography variant="h6">
                                      {displayPatientName(patient.name)}
                                    </Typography>
                                    <Typography variant="body2">
                                      ABHA Number: {patient.abha_no || "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                      Patient ID: {patient.patient_id}
                                    </Typography>
                                    <Typography variant="body2">
                                      ABHA Address: {patient.abha_id || "-"}
                                    </Typography>
                                    <Typography variant="body2">
                                      Gender: {patient.gender}
                                    </Typography>
                                    <Typography variant="body2">
                                      DOB: {patient.dob}
                                    </Typography>
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginTop: "10px",
                                }}
                              >
                                <Tooltip title="Add New Patient">
                                  <IconButton
                                    onClick={() => handleAddNewPatient(patient)}
                                    aria-label="add new patient"
                                  >
                                    <PersonAddAlt1Icon />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Update Patient">
                                  <IconButton
                                    onClick={() => handleUpdatePatient(patient)}
                                    aria-label="update patient"
                                  >
                                    <ManageAccountsIcon />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Cancel Update">
                                  <IconButton
                                    onClick={() =>
                                      handleCancelUpdate(patient.patient_id)
                                    }
                                    aria-label="cancel update"
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </form>
                </Box>
              )} */}

            {multipleMatchedData && multipleMatchedData.patient ? (
              multipleMatchedData.patient.length > 0 ? (
                <>
                  {/* <ProfileCard
                    profileData={{
                      healthIdNumber: multipleMatchedData.healthIdNumber,
                      healthId: multipleMatchedData.healthId,
                      name: multipleMatchedData.name,
                      yearOfBirth: multipleMatchedData.yearOfBirth,
                      monthOfBirth: multipleMatchedData.monthOfBirth,
                      dayOfBirth: multipleMatchedData.dayOfBirth,
                      profilePhoto: multipleMatchedData.profilePhoto,
                      gender: multipleMatchedData.gender,
                    }}
                  /> */}
                  <ProfileCard
                    profileData={{
                      healthIdNumber:
                        multipleMatchedData.healthIdNumber ||
                        multipleMatchedData.ABHANumber ||
                        multipleMatchedData.abhaNumber,
                      healthId:
                        multipleMatchedData.healthId ||
                        multipleMatchedData.preferredAbhaAddress ||
                        multipleMatchedData.abhaAddress,
                      name:
                        multipleMatchedData.name ||
                        `${multipleMatchedData.firstName} ${multipleMatchedData.lastName}`,
                      yearOfBirth: multipleMatchedData.yearOfBirth,
                      monthOfBirth: multipleMatchedData.monthOfBirth,
                      dayOfBirth: multipleMatchedData.dayOfBirth,
                      profilePhoto:
                        multipleMatchedData.profilePhoto ||
                        multipleMatchedData.kycPhoto,
                      gender: multipleMatchedData.gender,
                    }}
                  />

                  <Box
                    style={{
                      height: "600px",
                      overflow: "auto",
                      padding: "16px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  >
                    <form>
                      <Typography
                        variant="h6"
                        style={{ marginBottom: "20px", textAlign: "center" }}
                      >
                        Matched Profile(s) in the facility
                      </Typography>
                      <Grid container spacing={2}>
                        {multipleMatchedData.patient.map((patient, index) => (
                          <Grid item xs={12} sm={6} key={index}>
                            <Card
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                minHeight: "265px",
                                border:
                                  activePatientId === patient.patient_id
                                    ? "2px solid #21cdc0"
                                    : "none",
                                // border: (() => {
                                //   const isSelected = String(activePatientId) === String(patient.patient_id);
                                //   return isSelected ? "0 0 10px 2px blue" : "none";
                                //   border:
                                //   selectedPatId === patient.patient_id
                                //     ? "2px solid blue"
                                //     : "none",
                                // })(),
                                // marginBottom: "20px",
                                // height: "300px",
                              }}
                              onClick={() =>
                                handleCardSelectUpdate(patient.patient_id)
                              }
                            >
                              <CardContent
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Avatar
                                      alt={displayPatientName(patient.name)}
                                      src={`data:image/jpeg;base64,${patient.photo}`}
                                      style={{ marginRight: "20px" }}
                                    />
                                    <div>
                                      <Typography variant="h6" style={{ textTransform: "uppercase" }}>
                                        {displayPatientName(patient.name)}
                                      </Typography>
                                      <Typography variant="body2">
                                        ABHA Number: {patient.abha_no || "-"}
                                      </Typography>
                                      <Typography variant="body2">
                                        Patient ID: {patient.patient_id}
                                      </Typography>
                                      <Typography variant="body2">
                                        ABHA Address: {patient.abha_id || "-"}
                                      </Typography>
                                      <Typography variant="body2">
                                        Gender: {patient.gender}
                                      </Typography>
                                      <Typography variant="body2">
                                        DOB: {patient.DOB}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginTop: "10px",
                                  }}
                                >
                                  {/* <Tooltip title="Add New Patient">
                        <IconButton
                          onClick={() => handleAddNewPatient(patient)}
                          aria-label="add new patient"
                          style={{ color: "green" }}
                        >
                          <PersonAddAlt1Icon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Update Patient">
                        <IconButton
                          onClick={() => handleUpdatePatient(patient)}
                          aria-label="update patient"
                          style={{ color: "#ffa233" }}
                        >
                          <ManageAccountsIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Cancel Update">
                        <IconButton
                          onClick={() => handleCancelUpdate(patient.patient_id)}
                          aria-label="cancel update"
                          style={{ color: "red" }}
                        >
                          <CancelIcon />
                        </IconButton>
                      </Tooltip> */}
                                </div>
                              </CardContent>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </form>
                  </Box>

                  <Card>
                    <CardContent>
                      <Typography variant="h6" style={{ textAlign: "center" }}>
                        Actions
                      </Typography>
                      <Box display="flex" justifyContent="center" mt={2}>
                        {/* Add Patient */}
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            margin: "0 16px",
                          }}
                        >
                          <Tooltip title="Add New Patient" arrow>
                            <IconButton
                              onClick={handleAddNewPatient}
                              aria-label="add new patient"
                              style={{ color: "green" }}
                            >
                              <PersonAddAlt1Icon />
                            </IconButton>
                          </Tooltip>
                          <Typography variant="caption">Add Patient</Typography>
                        </Box>
                        {/* Update Action */}
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            margin: "0 16px",
                          }}
                        >
                          <Tooltip title="Update Patient">
                            <IconButton
                              onClick={() => {
                                console.log(
                                  "Active Patient ID:",
                                  activePatientId
                                );
                                handleUpdatePatient(activePatientId);
                              }}
                              aria-label="update patient"
                              disabled={!activePatientId}
                              sx={{ color: "#ffa233" }}
                            >
                              <ManageAccountsIcon />
                            </IconButton>
                          </Tooltip>
                          <Typography variant="caption">
                            Update Patient
                          </Typography>
                        </Box>
                        {/* Cancel Action */}
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            margin: "0 16px",
                          }}
                        >
                          <Tooltip title="Cancel" arrow>
                            <IconButton
                              onClick={handleCancelUpdate}
                              aria-label="cancel"
                              style={{ color: "red" }}
                            >
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>
                          <Typography variant="caption">Cancel</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </>
              ) : (
                <Card>
                  <CardContent>
                    <Typography variant="h6" style={{ textAlign: "center" }}>
                      No Patient Found
                    </Typography>
                    <Box display="flex" justifyContent="center" mt={2}>
                      <Tooltip title="Add New Patient">
                        <IconButton
                          onClick={handleAddNewPatient}
                          aria-label="add new patient"
                          style={{ color: "green" }}
                        >
                          <PersonAddAlt1Icon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Cancel">
                        <IconButton
                          onClick={() => handleCancelUpdate()}
                          aria-label="cancel"
                          style={{ color: "red" }}
                        >
                          <CancelIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </CardContent>
                </Card>
              )
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" variant="secondary" onClick={handleCloseVerifyModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
    </>
  );
};

export default VerifyAbha;
